export class PublishingHighlightData {
  title: string;
  subtitle: string;
  description: string;
  image: string;
  slug: string;
  pdf: string;
  menu: Array<any>;
  buttons: Array<{
    title: string;
    url: string;
    color: string;
    modal: string;
    page: string;
  }>;
  constructor(params?: PublishingHighlightData) {
    this.title = params?.title ? params?.title : null;
    this.subtitle = params?.subtitle ? params?.subtitle : null;
    this.description = params?.description ? params?.description : null;
    this.image = params?.image ? params?.image : null;
    this.slug = params?.slug ? params?.slug : null;
    this.pdf = params?.pdf ? params?.pdf : null;
    this.menu = params?.menu ? params?.menu : [];
    this.buttons = params?.buttons ? params?.buttons : [];
  }
}

export interface PublishingConfigsData {
  banner: string;
}

export interface PublishingAbout {
  category: string;
  title: string;
  subtitle: string;
  image: string;
  date: string;
  modal: string;
  description: string;
}

export interface PublishingItemMenu {
  title: string;
  url: string;
  icon?: string;
  pageLocation?: string;
}

export class PublishingHighlightButtonData {
  title: string;
  url: string;
  color: string;
  modal: any;
  page: string;

  constructor(params?: PublishingHighlightButtonData) {
    this.title = params?.title ? params?.title : 'Ler mais';
    this.url = params?.url ? params?.url : '';
    this.color = params?.color ? params?.color : 'Texto Primário';
    this.modal = params?.modal ? params?.modal : null;
    this.page = params?.page ? params?.page : '';
  }
}
